/**
* Question 类型
*/
export const QuestionType = {
    TextBox: "TextBox",
    CheckBox: 'CheckBox',
    DropdownList: 'DropdownList'
}


// WEBPACK FOOTER //
// ./src/consts/QuestionType.ts